import React from 'react';
import {Link} from 'react-router-dom';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import ReactTable from 'react-table';
import FontAwesome from 'react-fontawesome';
import firebase from 'firebase/app';
import 'firebase/database';
import NewExpoDialog from './new-expo-dialog';

/** @class ExpoList
  * A component for displaying a list of expos
  * and thier properties
  */
export default class ExpoList extends ReactFireComponent {
  /** @constructor
    * Constructs a new instance of ExpoList
    */
  constructor(props) {
    super(props);
    this.state = {
      expos: [],
      showNewExpoDialog: false
    }
    this.toggleNewExpoDialog = this.toggleNewExpoDialog.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }
  /** @method componentWillMount
    * Binds the component to the firebase database expo list
    */
  componentWillMount() {
    this.bindAsArray('/expos', 'expos');
  }
  /** @method componentWillUnmount
    * Unbinds the component from the firebase database
    */
  componentWillUnmount() {
    this.unbind('expos');
  }
  /** @method toggleNewExpoDialog
    * Shows the new expo dialog
    */
  toggleNewExpoDialog() {
    this.setState({showNewExpoDialog: !this.state.showNewExpoDialog})
  }
  /** @method handleDelete
    * Deletes an expo
    * @param {string} id - the identifier of the expo to delete
    */
  handleDelete(id) {
    var expo = this.state.expos.find(expo => expo.id === id);
    if(expo && window.confirm(`Are you sure? This will permanently delete the Expo ${expo.metadata.name} and all of its shows.`)) {
      firebase.database().ref(`expos/${id}`).set(null);
    }
  }
  /** @method render
    * Renders the component
    */
  render() {
    const columns = [
      {Header: "Expo", accessor: "metadata.name"},
      {Header: "Website", accessor: "metadata.host", Cell: (row) => (
        <a href={`https://${row.value}`}>{row.value}</a>
      )},
      {Header: "# of Shows", accessor: "shows", Cell: (row) => (
        Object.keys(row.value || []).length
      )},
      {Header: "Action", accessor: "id", Cell: (row) => (
        <div style={{textAlign: "center"}}>
          <Link to={`/expos/${row.value}`}>
            <FontAwesome name="edit"
              style={{color: 'orange'}}
              />
          </Link>
          <FontAwesome name="times"
            style={{color: 'red', cursor: 'pointer'}}
            onClick={() => this.handleDelete(row.value)}
            />
        </div>
      )}

    ]
    return (
      <div>
        <NewExpoDialog
          show={this.state.showNewExpoDialog}
          onExit={this.toggleNewExpoDialog}/>

        <button className="btn btn-success"
          onClick={this.toggleNewExpoDialog}
          >
            <FontAwesome name="plus"/>
            Add New Expo
        </button>

        <ReactTable
          className="-striped"
          data={this.state.expos}
          columns={columns}
          defaultPageSize={15}
          />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/expo-list/expo-list.js